module.exports = __webpack_public_path__ + "media/jump.429ada40.wav";